<template>
  <div>
    <el-collapse v-model="activeName" class="mb-2">
      <el-collapse-item name="1">
        <template slot="title">
          <div @click.stop="() => {}">
            <el-descriptions class="margin-top" :column="4" size="small" border>
              <el-descriptions-item
                :label="$l('form_label_goodsName') || '产品描述'"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.goodsName || '' }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_goodsSize') || '单品尺寸'"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.goodsSize || '' }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_unitCbm') || '单品体积'"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.unitCbm || '' }} m³
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_unitWeight') || '单品重量'"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.unitWeight || '' }} g
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_ftyPrice') || '工厂价'"
                :label-class-name="!isNotActiveName ? 'bb-none' : ''"
                :content-class-name="!isNotActiveName ? 'bb-none' : ''"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.ftyPrice || '' }}
                {{ formData.v_ftyCurrencyUnit || '' }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_ctnSize') || '外箱尺寸'"
                :label-class-name="!isNotActiveName ? 'bb-none' : ''"
                :content-class-name="!isNotActiveName ? 'bb-none' : ''"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.ctnSize || '' }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('form_label_inCtnQty') || '入数'"
                :label-class-name="!isNotActiveName ? 'bb-none' : ''"
                :content-class-name="!isNotActiveName ? 'bb-none' : ''"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                {{ formData.inCtnQty || '' }}
              </el-descriptions-item>
              <el-descriptions-item
                :label="$l('INDEX.choose_fabric_function') || '功能'"
                :label-class-name="!isNotActiveName ? 'bb-none' : ''"
                :content-class-name="!isNotActiveName ? 'bb-none' : ''"
                :labelStyle="{ width: '100px', height: '32px' }"
                :contentStyle="{ width: '235px', height: '32px' }"
              >
                <div class="d-flex f-b">
                  <div>
                    <el-button
                      size="mini"
                      plain
                      class="add-p-b mr-2"
                      v-if="!disabled"
                      @click="onOpenAddMarketplace"
                      >{{
                        $l('button_add_marketplace') || '新增市场'
                      }}</el-button
                    >
                    <el-dropdown trigger="click" @command="handleCommand">
                      <el-button
                        size="mini"
                        icon="el-icon-more"
                        plain
                        class="add-p-b bg-ef"
                      >
                      </el-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            icon="el-icon-view"
                            command="view"
                            >{{
                              $l('menu_text_detail') || '查看详情'
                            }}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-edit-outline"
                            v-if="!disabled"
                            command="edit"
                            >{{
                              $l('menu_text_edit') || '编辑数据'
                            }}</el-dropdown-item
                          >
                          <el-dropdown-item
                            icon="el-icon-delete"
                            command="del"
                            v-if="!disabled"
                            >{{
                              $l('menu_text_delete') || '删除数据'
                            }}</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                  <div>
                    <i
                      v-if="!isNotActiveName"
                      class="el-icon-arrow-down fs-20"
                      @click="changeActive('1')"
                    ></i>
                    <i
                      v-if="isNotActiveName"
                      class="el-icon-arrow-up  fs-20"
                      @click="changeActive('1')"
                    ></i>
                  </div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </template>
        <MarketDetailTable
          ref="marketDetailTableRef"
          :disabled="disabled"
          :isConfirmEdit="isConfirmEdit"
          :amzPriceControlCode="amzPriceControlCode"
          :amzPriceControlDetailCode="formData.amzPriceControlDetailCode"
        ></MarketDetailTable>
      </el-collapse-item>
    </el-collapse>

    <AddProduct
      v-if="showAddProduct"
      :type="type"
      :amzPriceControlCode="amzPriceControlCode"
      :amzPriceControlDetailCode="formData.amzPriceControlDetailCode"
      :disabled="disabled"
      @close="onCloseAddProduct"
      @reload="reloadData"
    ></AddProduct>

    <AddMarketplace
      v-if="showAddMarketplace"
      :type="type"
      :amzPriceControlCode="amzPriceControlCode"
      :amzPriceControlDetailCode="formData.amzPriceControlDetailCode"
      :disabled="disabled"
      @close="onCloseAddMarketplace"
      @reload="() => $emit('reload')"
    >
    </AddMarketplace>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import AddProduct from './AddProduct.vue'
import AddMarketplace from './AddMarketplace.vue'
import MarketDetailTable from '../market-detail-table'
export default {
  mixins: [EditLoading],
  components: { AddProduct, AddMarketplace, MarketDetailTable },
  props: {
    disabled: { type: Boolean, default: false },
    item: { tyep: Object, default: () => {} },
    isConfirmEdit: { type: Boolean, default: false },
    amzPriceControlCode: { type: String, default: '' },
  },
  watch: {
    item: {
      handler() {
        this.formData = { ...this.item }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formData: {},
      activeName: ['1'],
      type: '',
      showAddProduct: false,
      showAddMarketplace: false,
    }
  },
  computed: {
    isNotActiveName() {
      return !this.activeName.length
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    onCloseAddProduct() {
      this.showAddProduct = false
    },
    onOpenAddMarketplace() {
      this.showAddMarketplace = true
    },
    onCloseAddMarketplace() {
      this.showAddMarketplace = false
      this.$refs.marketDetailTableRef.getData()
    },
    handleCommand(command) {
      switch (command) {
        case 'view':
        case 'edit':
          this.showAddProduct = true
          this.type = command
          break
        case 'del':
          this.del()
          return
      }
    },
    async del() {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingClose()) return
      const res = await this.$api
        .ecomAmzPriceControlDetailDelApi({
          amzPriceControlDetailCode: this.formData.amzPriceControlDetailCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    reloadData() {
      this.$refs.marketDetailTableRef.getData()
      this.$emit('reload')
    },
    getData() {},
    changeActive(an) {
      const index = this.activeName.findIndex((e) => e == an)
      console.log(index)
      if (index != -1) {
        this.activeName.splice(index, 1)
      } else {
        this.activeName.push(an)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  color: #101010;
  font-weight: 600;
}
.add-p-b {
  border-radius: 4px !important;
}
.f-b {
  justify-content: space-between;
  align-items: center;
}
.fs-20 {
  font-size: 20px;
}
::v-deep {
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .el-form-item__content {
    line-height: 1 !important;
  }
  .el-collapse-item__header {
    display: block !important;
    border: none !important;
    height: auto !important;
    cursor: auto !important;
  }
  .el-collapse-item__arrow {
    display: none;
  }
  .el-collapse {
    border: none !important;
  }
  .el-collapse-item__wrap {
    border: none !important;
  }
  .el-collapse-item__content {
    .card-form {
      padding: 0 !important;
    }
  }
  .bb-none {
    border-bottom: none !important;
  }
}

.bg-ef {
  background-color: #efefef !important;
  border: none !important;
}
</style>
